import { sourceImage } from "../../utils/source-image.js";
/* Read-only student and class records. Dates affect study activity; tasks show current state. */
(function () {
  "use strict";

  window.DMSchoolSections = window.DMSchoolSections || {};
  window.DMSchoolSections.reports = function (ctx) {
    const {
      el: DMSchoolUi,
      b: DMSchoolUiAtual2,
      input,
      table,
      csv,
      fmt,
      date,
      minutes,
      yearLabel,
      totals,
      status,
      goalText,
    } = window.DMSchoolUi;
    const { api, house, render, heading, toolbar, empty, run } = ctx;
    let mode = "classes",
      from = "",
      until = "";
    const labels = {
      fechada: "Questões fechadas",
      flashcard: "Flashcards (autoavaliação)",
      aberta: "Questões abertas",
      resumo: "Resumo",
      video: "Videoaula",
      pagina: "Página",
    };
    const attempts = (value) =>
      Object.fromEntries(
        (value.period_attempts || []).map((item) => [
          item.kind,
          Number(item.attempts),
        ]),
      );
    const grade = (value) => (value == null ? "—" : fmt(value) + " / 10");
    const resultText = (value) =>
      "Acertos: " +
      fmt(value.correct) +
      " · Erros: " +
      fmt(value.incorrect) +
      (Number(value.partial) > 0 ? " · Parciais: " + fmt(value.partial) : "") +
      " · Nota: " +
      grade(value.first_average);
    const modalityResult = (value, index) =>
      resultText({
        correct: value[index + "_correct"],
        incorrect: value[index + "_incorrect"],
        partial: value[index + "_partial"],
        first_average: value[index + "_first_average"],
      });
    const countCell = (value, index) =>
      fmt(value[index]) + " feitas · " + modalityResult(value, index) +
      " · " + fmt(value[index + "_attempts"]) + " respostas";
    function gradeNote(element) {
      element.append(
        DMSchoolUi(
          "p", "ds-hint",
          "Acertos, erros e notas usam a primeira resposta de cada atividade. Notas de 0 a 10; a nota geral é a média de todas as atividades feitas, incluindo flashcards autoavaliados. Respostas parcialmente corretas ficam separadas dos erros. Sem respostas, a nota aparece como —.",
        ),
      );
    }
    function dates(element, refresh) {
      const form = DMSchoolUi("form", "ds-form ds-filter-bar"),
        inputResult = input(form, "from", "De", "date", from),
        inputResultAtual2 = input(form, "until", "Até", "date", until),
        button = DMSchoolUi(
          "button",
          "ds-button ds-primary",
          "Consultar período",
        );
      button.type = "submit";
      form.append(button);
      form.onsubmit = (event) => {
        event.preventDefault();
        from = inputResult.value;
        until = inputResultAtual2.value;
        run(refresh)();
      };
      element.append(form);
    }
    function metrics(element, rows) {
      const grid = DMSchoolUi("div", "ds-record-metrics");
      for (const [label, value, detail] of rows) {
        const card = DMSchoolUi("div", "ds-record-metric");
        card.append(
          DMSchoolUi("span", null, label),
          DMSchoolUi("strong", null, value),
        );
        if (detail) card.append(DMSchoolUi("small", null, detail));
        grid.append(card);
      }
      element.append(grid);
    }
    function block(element, title) {
      const box = DMSchoolUi("section", "ds-record-block");
      box.append(DMSchoolUi("h3", null, title));
      element.append(box);
      return box;
    }
    function person(element, item) {
      const hero = DMSchoolUi("div", "ds-record-hero");
      if (item.foto) {
        try {
          const url = new URL(sourceImage(item.foto), window.location.origin);
          if (["http:", "https:"].includes(url.protocol)) {
            const image = DMSchoolUi("img", "ds-record-photo");
            image.src = url.href;
            image.alt = "Foto de " + item.nome;
            hero.append(image);
          }
        } catch {}
      }
      const info = DMSchoolUi("div");
      info.append(
        DMSchoolUi("h2", null, item.nome),
        DMSchoolUi(
          "p",
          null,
          [yearLabel(item.ano), item.escola].filter(Boolean).join(" · ") ||
            "Aluno da instituição",
        ),
      );
      if (item.last_logged)
        info.append(
          DMSchoolUi(
            "small",
            null,
            "Último acesso: " +
              new Date(item.last_logged + "T12:00:00").toLocaleDateString(
                "pt-BR",
              ),
          ),
        );
      hero.append(info);
      element.append(hero);
    }
    function progress(task) {
      const wrap = DMSchoolUi("div", "ds-record-progress"),
        value = Math.min(100, Math.max(0, Number(task.progress_percent || 0))),
        bar = DMSchoolUi("div", "ds-record-bar"),
        fill = DMSchoolUi("span");
      fill.style.width = value + "%";
      bar.setAttribute("role", "progressbar");
      bar.setAttribute("aria-label", "Andamento da tarefa");
      bar.setAttribute("aria-valuemin", "0");
      bar.setAttribute("aria-valuemax", "100");
      bar.setAttribute("aria-valuenow", String(value));
      bar.append(fill);
      wrap.append(DMSchoolUi("strong", null, fmt(value) + "%"), bar);
      return wrap;
    }
    function taskName(value) {
      return value.lesson_title || "Atividade";
    }
    function tasks(value, index) {
      const box = block(value, "Tarefas recebidas");
      box.append(
        DMSchoolUi(
          "p",
          "ds-hint",
          "Situação atual das tarefas ativas. O filtro de datas acima se aplica às atividades de estudo.",
        ),
      );
      if (!index.tasks?.length)
        return empty(box, "Nenhuma tarefa ativa recebida.");
      table(
        box,
        ["Atividade", "Enviada por", "Prazo", "Situação", "Andamento"],
        index.tasks.map((item) => {
          const title = DMSchoolUi("div");
          title.append(DMSchoolUi("strong", null, taskName(item)));
          for (const optionalValue of item.goals || [])
            title.append(
              DMSchoolUi("small", "ds-record-goal", goalText(optionalValue)),
            );
          if (!item.goals?.length && item.guide_name)
            title.append(
              DMSchoolUi("small", "ds-record-goal", item.guide_name),
            );
          const badge = DMSchoolUi(
            "span",
            "ds-record-status" + (item.completed ? " ds-record-complete" : ""),
            status[item.status] || item.status,
          );
          return [
            title,
            item.sender_name,
            date(item.due_at),
            badge,
            progress(item),
          ];
        }),
      );
    }
    function events(value, rows, byClass = false) {
      const box = block(value, "Últimas atividades");
      box.append(
        DMSchoolUi(
          "p",
          "ds-hint",
          "Até 500 registros recentes do período. Os totais consideram todo o período.",
        ),
      );
      if (!rows.length)
        return empty(box, "Nenhuma atividade registrada neste período.");
      const values = rows.map((row) => [
        ...(byClass ? [row.student_name] : []),
        date(row.occurred_at),
        row.titulo || row.aula_id,
        row.guia || labels[row.kind] || row.kind,
        row.answered,
        row.correct,
        row.incorrect,
        row.partial,
        grade(row.average),
        minutes(row.summary_seconds),
        minutes(row.video_seconds),
      ]);
      toolbar(
        box,
        DMSchoolUiAtual2("Exportar atividades", () =>
          csv(
            "atividades",
            [
              "Aluno",
              "Data",
              "Aula",
              "Guia",
              "Respostas",
              "Acertos",
              "Erros",
              "Parciais",
              "Nota da resposta",
              "Leitura",
              "Vídeo",
            ].slice(byClass ? 0 : 1),
            values,
          ),
        ),
      );
      table(
        box,
        [
          ...(byClass ? ["Aluno"] : []),
          "Data",
          "Aula",
          "Guia",
          "Respostas",
          "Acertos",
          "Erros",
          "Parciais",
          "Nota da resposta",
          "Leitura",
          "Vídeo",
        ],
        values,
      );
    }
    function studentReport(value, options = {}) {
      return render(async (element) => {
        element.classList.add("ds-record-view");
        const callResult = await api.call(
          options.action || "student-period-report",
          {
            institution_id: house,
            student_id: value,
            from,
            until,
          },
        );
        toolbar(
          element,
          DMSchoolUiAtual2(
            options.backLabel || "Voltar aos alunos",
            options.back || (() => reports("students")),
          ),
        );
        person(element, callResult.student);
        dates(element, () => studentReport(value, options));
        const totalsResult = totals({
            items: callResult.period_items,
          }),
          attemptsResult = attempts(callResult),
          resultado = callResult.task_summary || {};
        metrics(element, [
          [
            "Horas de estudo",
            fmt(callResult.period_study_seconds / 3600) + " h",
            "No período escolhido",
          ],
          [
            "Questões fechadas",
            fmt(totalsResult.fechada.answered),
            resultText(totalsResult.fechada) + " · " +
              fmt(attemptsResult.fechada) +
              " respostas",
          ],
          [
            "Flashcards (autoavaliação)",
            fmt(totalsResult.flashcard.answered),
            resultText(totalsResult.flashcard) + " · " +
              fmt(attemptsResult.flashcard) +
              " respostas",
          ],
          [
            "Questões abertas",
            fmt(totalsResult.aberta.answered),
            resultText(totalsResult.aberta) + " · " +
              fmt(attemptsResult.aberta) +
              " respostas",
          ],
          [
            "Nota geral",
            grade(callResult.period_summary?.first_average),
            fmt(callResult.period_summary?.answered) + " atividades feitas no período",
          ],
          [
            "Tarefas concluídas",
            fmt(resultado.completed),
            fmt(resultado.assigned) + " recebidas",
          ],
          [
            "Tarefas pendentes",
            fmt(resultado.pending),
            fmt(resultado.in_progress) + " em andamento",
          ],
        ]);
        gradeNote(element);
        const time = block(element, "Como o tempo foi utilizado");
        metrics(time, [
          [
            "Leitura de resumos",
            minutes(callResult.period_seconds?.summary_seconds),
            "No período",
          ],
          [
            "Videoaulas",
            minutes(callResult.period_seconds?.video_seconds),
            "No período",
          ],
          [
            "Página aberta em estudo",
            minutes(callResult.period_seconds?.page_seconds),
            "Inclui as modalidades registradas",
          ],
        ]);
        time.append(DMSchoolUi("p", "ds-hint", callResult.time_coverage_note));
        tasks(element, callResult);
        const subjects = block(element, "Atividades por assunto");
        subjects.append(
          DMSchoolUi(
            "p",
            "ds-hint",
            "Questões novas são contadas uma vez. Respostas incluem as repetições aceitas. Acertos usam a primeira resposta; flashcards usam a autoavaliação.",
          ),
        );
        const values = (callResult.subjects || []).map((item) => [
          item.titulo,
          item.guia,
          labels[item.kind] || item.kind,
          item.answered,
          item.correct,
          item.incorrect,
          item.partial,
          grade(item.first_average),
          date(item.last_at),
        ]);
        toolbar(
          subjects,
          DMSchoolUiAtual2("Exportar assuntos", () =>
            csv(
              "aluno-" + value,
              ["Aula", "Guia", "Tipo", "Feitas", "Acertos", "Erros", "Parciais", "Nota inicial", "Data"],
              values,
            ),
          ),
        );
        if (!values.length)
          empty(
            subjects,
            "Nenhuma primeira resposta registrada neste período.",
          );
        else
          table(
            subjects,
            [
              "Aula",
              "Guia",
              "Tipo",
              "Feitas",
              "Acertos",
              "Erros",
              "Parciais",
              "Nota inicial",
              "Última primeira resposta",
            ],
            values,
          );
        events(element, callResult.event_activities || []);
        const historical = DMSchoolUi("details", "ds-record-history");
        historical.append(DMSchoolUi("summary", null, "Acumulado preservado"));
        table(
          historical,
          [
            "Tipo",
            "Feitas",
            "Acertos iniciais",
            "Erros iniciais",
            "Parciais iniciais",
            "Nota inicial",
            "Última nota",
            "Tentativas",
          ],
          (callResult.items || []).map((item) => [
            labels[item.kind] || item.kind,
            item.answered,
            item.correct,
            item.incorrect,
            item.partial,
            fmt(item.first_average),
            fmt(item.last_average),
            item.attempts,
          ]),
        );
        historical.append(
          DMSchoolUi(
            "p",
            "ds-hint",
            "Resumo: " +
              minutes(callResult.seconds?.summary_seconds) +
              " · Vídeo: " +
              minutes(callResult.seconds?.video_seconds) +
              " · Página: " +
              minutes(callResult.seconds?.page_seconds),
          ),
        );
        element.append(historical);
      }, { live: true });
    }
    function classRecord(value, options = {}) {
      return render(async (element) => {
        element.classList.add("ds-record-view");
        const callResult = await api.call(
          options.action || "class-period-report",
          {
            id: value,
            from,
            until,
          },
        );
        toolbar(
          element,
          DMSchoolUiAtual2(
            "Voltar às turmas",
            options.back || (() => reports("classes")),
          ),
        );
        heading(
          element,
          callResult.class.name,
          [yearLabel(callResult.class.school_year), callResult.class.subject]
            .filter(Boolean)
            .join(" · "),
        );
        dates(element, () => classRecord(value, options));
        const summary = callResult.summary;
        metrics(element, [
          [
            "Alunos",
            fmt(callResult.students.length),
            fmt(summary.active_students) + " com estudo no período",
          ],
          [
            "Horas de estudo",
            fmt(summary.study_seconds / 3600) + " h",
            "Soma dos alunos desta turma",
          ],
          [
            "Questões fechadas",
            fmt(summary.closed),
            modalityResult(summary, "closed") + " · " +
              fmt(summary.closed_attempts) +
              " respostas",
          ],
          [
            "Flashcards (autoavaliação)",
            fmt(summary.flashcard),
            modalityResult(summary, "flashcard") + " · " +
              fmt(summary.flashcard_attempts) +
              " respostas",
          ],
          [
            "Questões abertas",
            fmt(summary.open),
            modalityResult(summary, "open") + " · " +
              fmt(summary.open_attempts) +
              " respostas",
          ],
          [
            "Nota geral",
            grade(callResult.answer_summary?.first_average),
            fmt(callResult.answer_summary?.answered) + " atividades feitas pela turma",
          ],
          [
            "Tarefas concluídas",
            fmt(summary.completed) + " / " + fmt(summary.assigned),
            fmt(summary.pending) + " entregas pendentes",
          ],
        ]);
        gradeNote(element);
        metrics(element, [
          ["Resumo", minutes(summary.summary_seconds), "No período"],
          ["Videoaula", minutes(summary.video_seconds), "No período"],
        ]);
        element.append(
          DMSchoolUi("p", "ds-hint", callResult.time_coverage_note),
        );
        const studentBox = block(element, "Alunos da turma");
        if (!callResult.students.length)
          empty(studentBox, "Nenhum aluno vinculado a esta turma.");
        else
          table(
            studentBox,
            [
              "Aluno",
              "Fechadas",
              "Flashcards",
              "Abertas",
              "Nota geral",
              "Horas",
              "Tarefas concluídas",
            ],
            callResult.students.map((student) => [
              DMSchoolUiAtual2(
                student.nome,
                () =>
                  studentReport(student.id, {
                    action: options.studentAction || "student-period-report",
                    back: () => classRecord(value, options),
                    backLabel: "Voltar à turma",
                  }),
                "ds-record-link",
              ),
              countCell(student, "closed"),
              countCell(student, "flashcard"),
              countCell(student, "open"),
              grade(student.answer_summary?.first_average),
              fmt(student.study_seconds / 3600),
              fmt(student.task_summary.completed) +
                " / " +
                fmt(student.task_summary.assigned),
            ]),
          );
        const taskBox = block(element, "Tarefas e entregas da turma");
        if (!callResult.tasks.length)
          empty(
            taskBox,
            "Nenhuma tarefa ativa enviada aos alunos desta turma.",
          );
        for (const task of callResult.tasks) {
          const detail = DMSchoolUi("details", "ds-record-task");
          detail.append(
            DMSchoolUi(
              "summary",
              null,
              taskName(task) +
                " · " +
                task.completed +
                " de " +
                task.assigned +
                " concluídas · " +
                fmt(task.completion_percent) +
                "%",
            ),
          );
          detail.append(
            DMSchoolUi(
              "p",
              "ds-hint",
              "Enviada por " +
                task.sender_name +
                " · Prazo: " +
                date(task.due_at),
            ),
          );
          table(
            detail,
            ["Aluno", "Situação", "Andamento", "Metas"],
            task.students.map((student) => [
              DMSchoolUiAtual2(
                student.nome,
                () =>
                  studentReport(student.student_id, {
                    action: options.studentAction || "student-period-report",
                    back: () => classRecord(value, options),
                    backLabel: "Voltar à turma",
                  }),
                "ds-record-link",
              ),
              status[student.status] || student.status,
              progress(student),
              (student.goals || []).map(goalText).join(" · ") ||
                "Entrega escrita",
            ]),
          );
          taskBox.append(detail);
        }
        events(element, callResult.event_activities || [], true);
      }, { live: true });
    }
    function reports(next = mode) {
      if (typeof next !== "string") next = mode;
      mode = next;
      return render(async (element) => {
        heading(element, "Relatórios dos alunos");
        toolbar(
          element,
          DMSchoolUiAtual2(
            "Por turma",
            () => reports("classes"),
            mode === "classes" ? "ds-button ds-primary" : "ds-button",
          ),
          DMSchoolUiAtual2(
            "Por aluno",
            () => reports("students"),
            mode === "students" ? "ds-button ds-primary" : "ds-button",
          ),
        );
        dates(element, () => reports());
        if (mode === "students") {
          const callResultAtual2 = await api.call("report-students", {
              institution_id: house,
            }),
            search = DMSchoolUi("input", "ds-search");
          search.type = "search";
          search.setAttribute("aria-label", "Pesquisar aluno");
          element.append(search);
          const list = DMSchoolUi("div");
          element.append(list);
          let page = 0;
          const draw = () => {
            list.replaceChildren();
            const rows = callResultAtual2.students.filter((student) =>
              student.nome
                .toLocaleLowerCase("pt-BR")
                .includes(search.value.toLocaleLowerCase("pt-BR")),
            );
            page = Math.min(page, Math.max(0, Math.ceil(rows.length / 20) - 1));
            table(
              list,
              ["Aluno", "Ano escolar", "Turmas", "Relatório"],
              rows
                .slice(page * 20, (page + 1) * 20)
                .map((item) => [
                  DMSchoolUiAtual2(
                    item.nome,
                    () => studentReport(item.id),
                    "ds-record-link",
                  ),
                  yearLabel(item.ano),
                  item.class_names || "Sem turma",
                  DMSchoolUiAtual2("Ver relatório", () =>
                    studentReport(item.id),
                  ),
                ]),
            );
            const prev = DMSchoolUiAtual2("Anterior", () => {
                page--;
                draw();
              }),
              next = DMSchoolUiAtual2("Próxima", () => {
                page++;
                draw();
              });
            prev.disabled = !page;
            next.disabled = (page + 1) * 20 >= rows.length;
            toolbar(
              list,
              prev,
              DMSchoolUi(
                "span",
                null,
                "Página " + (page + 1) + " · " + rows.length + " alunos",
              ),
              next,
            );
          };
          search.oninput = () => {
            page = 0;
            draw();
          };
          draw();
          return;
        }
        const callResult = await api.call("class-comparison", {
          institution_id: house,
          from,
          until,
        });
        if (!callResult.classes.length)
          return empty(element, "Nenhuma turma ativa cadastrada.");
        const values = callResult.classes.map((item) => [
          item.name,
          yearLabel(item.school_year),
          item.students_count,
          countCell(item, "closed"),
          countCell(item, "flashcard"),
          countCell(item, "open"),
          grade(item.answer_summary?.first_average),
          fmt(item.study_seconds / 3600),
        ]);
        toolbar(
          element,
          DMSchoolUiAtual2("Exportar comparação", () =>
            csv(
              "comparacao-turmas",
              [
                "Turma",
                "Ano",
                "Alunos",
                "Fechadas",
                "Flashcards",
                "Abertas",
                "Nota geral",
                "Horas de estudo",
              ],
              values,
            ),
          ),
        );
        table(
          element,
          [
            "Turma",
            "Ano",
            "Alunos",
            "Fechadas",
            "Flashcards",
            "Abertas",
            "Nota geral",
            "Horas",
            "Detalhes",
          ],
          values.map((item, index) => [
            DMSchoolUiAtual2(
              item[0],
              () => classRecord(callResult.classes[index].id),
              "ds-record-link",
            ),
            ...item.slice(1),
            DMSchoolUiAtual2("Ver relatório", () =>
              classRecord(callResult.classes[index].id),
            ),
          ]),
        );
        element.append(
          DMSchoolUi(
            "p",
            "ds-hint",
            "Um aluno vinculado a duas turmas aparece em ambas. Alunos distintos: " +
              callResult.unique_students +
              ".",
          ),
        );
      }, { live: true });
    }
    return {
      reports,
      studentReport,
      classRecord,
    };
  };
})();
